import React from "react";
import PropTypes from "prop-types";

const FaceSign = (props) => {
  const { className, style } = props;
  return (
    <svg
      className={className}
      style={style}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.59998 7.56591C1.59998 4.27105 4.27098 1.60004 7.56585 1.60004H11.3623V4.85415H7.56585C6.06819 4.85415 4.85409 6.06824 4.85409 7.56591V11.3624H1.59998V7.56591Z"
        fill="url(#paint0_linear_1629:45235)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.7011 5.9389C10.9085 5.9389 7.02344 9.824 7.02344 14.6165V15.8998C7.02344 20.4561 10.1752 24.4065 14.6177 25.4184L15.2192 25.5554C15.5364 25.6277 15.8658 25.6277 16.1829 25.5554L16.7845 25.4184C21.2269 24.4065 24.3787 20.4561 24.3787 15.8998V14.6165C24.3787 9.82401 20.4936 5.9389 15.7011 5.9389ZM21.1246 15.8998V14.6165C21.1246 11.6212 18.6964 9.19302 15.7011 9.19302C12.7057 9.19302 10.2776 11.6212 10.2776 14.6165V15.8998C10.2776 18.9374 12.3788 21.571 15.3404 22.2455L15.7011 22.3277L16.0618 22.2455C19.0234 21.571 21.1246 18.9374 21.1246 15.8998Z"
        fill="url(#paint1_linear_1629:45235)"
      />
      <path
        d="M23.8365 1.60004C27.1313 1.60004 29.8024 4.27105 29.8024 7.56591V11.3624H26.5482V7.56591C26.5482 6.06824 25.3341 4.85415 23.8365 4.85415H20.04V1.60004H23.8365Z"
        fill="url(#paint2_linear_1629:45235)"
      />
      <path
        d="M29.8024 23.8364C29.8024 27.1312 27.1313 29.8023 23.8365 29.8023H20.04V26.5481H23.8365C25.3341 26.5481 26.5482 25.334 26.5482 23.8364V20.0399H29.8024V23.8364Z"
        fill="url(#paint3_linear_1629:45235)"
      />
      <path
        d="M7.56585 26.5481H11.3623V29.8023H7.56584C4.27098 29.8022 1.59998 27.1312 1.59998 23.8364V20.0399H4.85409V23.8364C4.85409 25.334 6.06819 26.5481 7.56585 26.5481Z"
        fill="url(#paint4_linear_1629:45235)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1629:45235"
          x1="8.31159"
          y1="11.9256"
          x2="3.5107"
          y2="5.36552"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AEAEB" />
          <stop offset="1" stop-color="#4871F0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1629:45235"
          x1="18.9552"
          y1="26.7445"
          x2="8.9812"
          y2="14.7198"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AEAEB" />
          <stop offset="1" stop-color="#4871F0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1629:45235"
          x1="26.7516"
          y1="11.9256"
          x2="21.9507"
          y2="5.36554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AEAEB" />
          <stop offset="1" stop-color="#4871F0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1629:45235"
          x1="26.7516"
          y1="30.3655"
          x2="21.9507"
          y2="23.8054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AEAEB" />
          <stop offset="1" stop-color="#4871F0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1629:45235"
          x1="8.31159"
          y1="30.3655"
          x2="3.51067"
          y2="23.8054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AEAEB" />
          <stop offset="1" stop-color="#4871F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

FaceSign.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

FaceSign.defaultProps = {
  className: undefined,
  style: undefined,
};

export default FaceSign;
